'use strict'

export default function (): void {
  document.addEventListener('click', function (e) {
    const target = e.target as HTMLElement

    if (target.matches('.open-tripadvisor-reviews')) {
      e.preventDefault()

      const button = document.getElementById('toggle-tripadvisor-reviews')

      if (button) {
        button.click()
      }
    }

    if (target.matches('.open-reviews')) {
      e.preventDefault()

      const button = document.getElementById('toggle-reviews')

      if (button) {
        button.click()
      }
    }
  })

  document.querySelectorAll<HTMLButtonElement>('.product__reviews-content .reviews__toggle button').forEach(function (el) {
    el.addEventListener('click', function (this: HTMLElement) {
      const visibleContentEl = document.querySelector('.product__reviews-content .reviews__block--visible')
      const activeButtonEl = document.querySelector('.product__reviews-content .toggle--active')

      if (visibleContentEl) {
        visibleContentEl.classList.remove('reviews__block--visible')
      }

      if (activeButtonEl) {
        activeButtonEl.classList.remove('toggle--active')
      }

      const target = this.getAttribute('data-target') as string
      this.classList.add('toggle--active')

      document.querySelector(target)?.classList.add('reviews__block--visible')
    })
  })
}
